import { Col, Row } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { ButtonGroup, NavigationButton } from '../../generic';
import { icons } from '../../generic/Icon';

import styles from './ProjectPreview.module.less';

/**
 * Call-to-action section encouraging users to sign up for FOSSA
 */
const CTASection: VoidFunctionComponent = () => (
  <div className={styles.ctaPanel}>
    <Row>
      <Col md={6} className="text-left">
        <h1 className={styles.ctaTitle}>Want FOSSA for your project?</h1>
      </Col>
      <Col md={6} className="text-right">
        <ButtonGroup>
          <NavigationButton
            to="/account/github_login?ref=project_preview"
            icon={icons.github}
            size="large"
            openInNewTab
          >
            Sign in with Github
          </NavigationButton>
          <NavigationButton
            to="/auth/register"
            icon={icons.envelope}
            size="large"
            type="secondary"
          >
            Sign up with Email
          </NavigationButton>
        </ButtonGroup>
      </Col>
    </Row>
  </div>
);

export default CTASection;
